"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var Map = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "map" },
            react_1.default.createElement("path", { id: "Icon", d: "M2 6L1.50386 5.13176C1.19229 5.3098 1 5.64114 1 6H2ZM2 22H1C1 22.3565 1.18976 22.686 1.49807 22.8649C1.80639 23.0438 2.18664 23.0451 2.49614 22.8682L2 22ZM16 22L15.5039 22.8682C15.8327 23.0562 16.2395 23.0422 16.5547 22.8321L16 22ZM22 18L22.5547 18.8321C22.8329 18.6466 23 18.3344 23 18H22ZM22 2H23C23 1.6312 22.797 1.29234 22.4719 1.11833C22.1467 0.944306 21.7522 0.963379 21.4453 1.16795L22 2ZM9 2L9.49614 1.13176C9.18871 0.956081 8.81129 0.956081 8.50386 1.13176L9 2ZM1 6V22H3V6H1ZM2.49614 22.8682L9.49614 18.8682L8.50386 17.1318L1.50386 21.1318L2.49614 22.8682ZM8.50386 18.8682L15.5039 22.8682L16.4961 21.1318L9.49614 17.1318L8.50386 18.8682ZM16.5547 22.8321L22.5547 18.8321L21.4453 17.1679L15.4453 21.1679L16.5547 22.8321ZM23 18V2H21V18H23ZM21.4453 1.16795L15.4453 5.16795L16.5547 6.83205L22.5547 2.83205L21.4453 1.16795ZM16.4961 5.13176L9.49614 1.13176L8.50386 2.86824L15.5039 6.86824L16.4961 5.13176ZM8.50386 1.13176L1.50386 5.13176L2.49614 6.86824L9.49614 2.86824L8.50386 1.13176ZM17 22V6H15V22H17ZM8 2V18H10V2H8Z" }))));
};
exports.default = Map;
